<template>
  <div class="shadow entry-overview flex overflow-hidden bg-white sm:rounded-lg">
    <!-- project entry detail -->
    <project-detail
      :activities="activities"
      :project="project"
      :clients="clients"
      :available-statuses="availableStatuses"
    />
  </div>
</template>

<script>
import ProjectDetail from '../../ComponentsDeprecated/ProjectDetail.vue';

export default {
  components: {
    ProjectDetail,
  },
  props: {
    activities: {
      type: Array,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    clients: {
      type: Array,
      required: true,
    },
    availableStatuses: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
//
</style>
